import React from 'react';
import { Image, styled, css } from '@volkswagen-onehub/components-core';

const CoverImage = styled(Image)<{ $isPrintMode?: boolean }>`
  height: 500px;
  object-fit: cover;

  ${({ $isPrintMode }) =>
    $isPrintMode &&
    css`
      width: 100%;
      height: auto;
      max-height: 1056px; /* US Letter height (11 inches) at 96 DPI */
      object-fit: cover;
    `}
`;

interface CoverImageFeatureProps {
  imgUrl?: string;
  altText?: string;
  isPrintMode?: boolean;
}

const mockCoverImg =
  '/assets/quick-start-guide/static/Access_California_Emissions_Parts_Desktop.jpg';

export const CoverImageFeature = ({
  imgUrl,
  altText,
  isPrintMode,
}: CoverImageFeatureProps) => {
  return (
    <CoverImage
      className='cover-image-feature'
      alt={altText}
      src={imgUrl ?? mockCoverImg}
      $isPrintMode={isPrintMode}
    />
  );
};
